import Vue from 'vue'
import api from '../api/api'
import zsrzComp from '../components/zsrz'
import messageTip from "../components/messageTip";

Vue.config.productionTip = false
Vue.prototype.$http = api

console.log('zsrz')

// var zsrzForm = new Vue({
//     el: '#zsrz-form',
//     data: {
//         "Name":"aa",
//         "Industry":null,
//         "Contact":null,
//         "ContactPhone":null,
//         "Address":null
//     },
//     methods: {
//         regist: function () {
//             console.log('regist start')
//             zsrzForm.$http.post('/api/enterprise/register', zsrzForm.$data, function(data){
//                 console.log(data);
//             }, function (data) {
//                 console.log(data);
//             })
//         }
//     }
// });

new Vue({
    render: h => h(zsrzComp),
}).$mount('#zsrz-form')

new Vue({
    render: h => h(messageTip)
}).$mount('#messageTip');

// var zsrz = new Vue({
//   el: '.zsrz_frform',
//   data: {
//     "Name":null,
//     "Industry":null,
//     "Contact":null,
//     "ContactPhone":null,
//     "Address":null
//   },
//   methods: {
//     regist: function () {
//       this.$http.post('/api/enterprise/register', zsrz.$data, function(data){
//         console.log(data);
//       }, function (data) {
//         console.log(data);
//       })
//     }
//   }
// });